import { RigRateDetailBase } from './base/rig-rate-detail-base';

export class RigRateDetail extends RigRateDetailBase { }